// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3m-x4","title":"styles_title__1amKl"};